<template lang="pug">
  div
    el-row#card-zoom(type="flex", justify="center")
      el-col.col-container(:span="2")
        el-button#iconZoom.zoomOut(@click="zoomOut")
          i.fal.fa-search-minus
      el-col.col-container(:span="2")
        el-button#iconZoom(disabled) {{ this.scaleZoomPorcentagem }}%
      el-col.col-container(:span="2")
        el-button#iconZoom.zoomIn(@click="zoomIn")
          i.fal.fa-search-plus
      el-col.col-container(:span="2")
        el-button#iconZoom.rotateLeft(@click="rotateLeft")
          i.fal.fa-undo-alt
      el-col.col-container(:span="2")
        el-button#iconZoom.rotateRight(@click="rotateRight")
          i.fal.fa-redo-alt
    div#image.card-info(shadow="hover" :style="customStyle || {}")
      app-vue-perfect-scrollbar.scroll-area(v-once='', :settings='settings')
        div
          img#img(:src="imgUrl(bytes)")
</template>

<script>
import AppVuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    AppVuePerfectScrollbar
  },

  props: {
    bytes: {
      type: ArrayBuffer
    },
    customStyle: {
      type: Object
    },
    base64: {
      type: String
    }
  },

  data () {
    return {
      settings: {
        maxScrollbarLength: 60
      },
      scaleZoomPorcentagem: 100,
      widthImage: null,
      rotationAngle: 0
    }
  },

  methods: {
    async zoomIn () {
      const image = document.getElementById('img')
      this.scaleZoomPorcentagem = await this.scaleZoomPorcentagem + 5

      if (this.widthImage === null) {
        this.widthImage = image.clientWidth
      }

      image.style.width = (this.scaleZoomPorcentagem * this.widthImage) / 100 + 'px'
    },

    async zoomOut () {
      if (this.scaleZoomPorcentagem > 30) {
        const image = document.getElementById('img')

        this.scaleZoomPorcentagem = await this.scaleZoomPorcentagem - 5

        if (this.widthImage === null) {
          this.widthImage = image.clientWidth
        }

        image.style.width = (this.scaleZoomPorcentagem * this.widthImage) / 100 + 'px'
      }
    },

    rotateLeft () {
      this.rotationAngle -= 90
      if (this.rotationAngle < 0) {
        this.rotationAngle += 360
      }
      const image = document.getElementById('img')
      image.style.transform = `rotate(${this.rotationAngle}deg)`
    },

    rotateRight () {
      this.rotationAngle += 90
      if (this.rotationAngle >= 360) {
        this.rotationAngle -= 360
      }
      const image = document.getElementById('img')
      image.style.transform = `rotate(${this.rotationAngle}deg)`
    },

    imgUrl (imagem) {
      if (this.base64) {
        return this.base64
      }
      const intArray = new Uint8Array(imagem)
      const reducedArray = intArray.reduce((data, byte) => data + String.fromCharCode(byte), '')

      const base64String = `data:image/png;base64, ${btoa(reducedArray)}`

      return base64String
    }

  }

}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/_variables.scss';

#image {
  text-align: center;
  margin: 1%;
  border-radius: 15px;
  height: 500px;
  margin-top: 1rem;
  margin-left: 0px;
  margin-right: 0px;
  border: 1px solid #eaeef1;
  width: 100%;
}

#img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 600px;
  object-fit: contain;
}

.scroll-area {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: auto;
  height: 100%;
  background-color: transparent;
  border-radius: 15px;
  border: 1px solid #eaeef1;
}

.card-info {
  border-radius: 15px;
  background-color: #4F4F4F;
  border-color: #eaeef1;
  margin: 2%;
}

#card-zoom {
  margin: 0 auto;
  height: 50px;
  margin: -20px 0 -10px;
}

#iconZoom {
  margin-top: 5px;
  margin-bottom: 5px;
  background-color: hsl(0, 0%, 50%);
  border-radius: 5px;
}

.fa-search-minus, .fa-search-plus, .fa-undo-alt, .fa-redo-alt {
  color: #fff;
}

.fa-search-plus {
color: #fff;
}

.col-container {
  display: flex;
  justify-content: center;
}

</style>



// WEBPACK FOOTER //
// src/components/AppImageViewer.vue